import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "21",
  height: "21",
  viewBox: "0 0 21 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M3.59961 2.43359C3.33439 2.43359 3.08004 2.53895 2.8925 2.72649C2.70497 2.91402 2.59961 3.16838 2.59961 3.43359V17.4336C2.59961 17.6988 2.70497 17.9532 2.8925 18.1407C3.08004 18.3282 3.33439 18.4336 3.59961 18.4336H7.59961C8.1519 18.4336 8.59961 18.8813 8.59961 19.4336C8.59961 19.9859 8.1519 20.4336 7.59961 20.4336H3.59961C2.80396 20.4336 2.0409 20.1175 1.47829 19.5549C0.91568 18.9923 0.599609 18.2292 0.599609 17.4336V3.43359C0.599609 2.63794 0.91568 1.87488 1.47829 1.31227C2.0409 0.749664 2.80396 0.433594 3.59961 0.433594H7.59961C8.1519 0.433594 8.59961 0.881309 8.59961 1.43359C8.59961 1.98588 8.1519 2.43359 7.59961 2.43359H3.59961ZM13.8925 4.72649C14.283 4.33596 14.9162 4.33596 15.3067 4.72649L20.3067 9.72649C20.6972 10.117 20.6972 10.7502 20.3067 11.1407L15.3067 16.1407C14.9162 16.5312 14.283 16.5312 13.8925 16.1407C13.502 15.7502 13.502 15.117 13.8925 14.7265L17.1854 11.4336H7.59961C7.04733 11.4336 6.59961 10.9859 6.59961 10.4336C6.59961 9.88131 7.04733 9.43359 7.59961 9.43359H17.1854L13.8925 6.1407C13.502 5.75018 13.502 5.11701 13.8925 4.72649Z",
  fill: "#56AF40"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render };